import { PublicKey } from "@solana/web3.js";

// === Execution & Fee Constants ===

// Maximum compute units this program allows per transaction.
// This is passed to the ComputeBudgetProgram to define resource consumption.
export const COMPUTE_UNIT_LIMIT = 25_000;

// Default commitment level used when querying Solana RPC.
// 'confirmed' ensures the transaction has reached a finalized state on most forks.
export const DEFAULT_COMMITMENT = 'confirmed';

// Micro-lamport conversion ratio (1 lamport = 1,000,000 micro-lamports).
// Used to express compute unit prices in finer granularity.
export const MICRO_LAMPORTS_PER_LAMPORT = 1_000_000;


// === Program & Account Identifiers ===

// Faucet account for message contribution.
// Used to subsidize access for users unable to pay directly.
export const FAUCET_ID = new PublicKey('ErDWj9hQPNn3F4v4ksVEWBhFqKwVrTLbNFhj6mfDxfA3');

// Foundation account for message contribution.
// Supports long-term maintenance and development of the protocol.
export const FOUNDATION_ID = new PublicKey('FT2eXkht5W2A1B9m1rg3eVM2v3o4sBmHNzfVCtpZ1WNR');

// Hardcoded authority address allowed to update the minimum fee PDA.
// It is the sole key permitted to configure the required message fee.
// On-chain, this address is verified during the 0x01 "update fee" instruction.
// It cannot escalate privileges or affect any other program behavior.
export const UNLINK_PROGRAM_CONFIG_AUTHORITY = new PublicKey('unLnkUUfFXfCwZaD34aCgXQqrXUiQNZhma3R4yLpjpi');

// Main program ID for the Unlink message protocol.
// All encrypted message transactions are dispatched to this program.
export const UNLINK_PROGRAM_ID = new PublicKey('unLnkSYfbSLKjmk8wMnKRCSCUXxFCYFvkuHPV71HpMQ');

// The Solana system program — required for transfers or allocating lamports.
// This is a well-known, fixed ID used in almost all Solana programs.
export const SYSTEM_PROGRAM_ID = new PublicKey('11111111111111111111111111111111');